module.exports = __webpack_public_path__ + "img/global-2014-zuckerman.cc9c89ca.jpg";